import * as React from "react";
import "./project-edit.css";
import MyDatePicker from "../../../components/date-picker/date-picker";
import LabeledInput from "../../../components/labeled-input/labeled-input";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { KeyValueStore } from "../../../stores/key-value/key-value-store";
import { Contact } from "../../../stores/contact/contact-store";
import { Grid, GridColumn, Input } from "semantic-ui-react";
import { SoilImprovementProject } from "../../../stores/project/project";
import LabeledValue from "../../../components/labeled-value/labeled-value";
import { Municipality } from "../../../stores/municipality/municipality-store";
import { getDesc, getLabel } from "../../../reflection/reflection";

export default function SoilImprovementEdit({
                                                project,
                                                municipalities,
                                                contacts,
                                                keyValueStore
                                            }: {
    project: SoilImprovementProject;
    municipalities: Municipality[];
    contacts: Contact[];
    keyValueStore: KeyValueStore
}): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridColumn largeScreen={16} widescreen={8}>
                    <LabeledValue
                        label={getLabel(project, "fullType")}
                        value={project.type}
                        required={true}/>
                    <LabeledInput
                        label="Name"
                        inputElement={
                            <Input
                                type="text"
                                name="name"
                                defaultValue={project.name}
                                maxLength={50}
                            />
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(project, "municipalityName")}
                        desc={getDesc(project, "municipalityName")}
                        inputElement={
                            <select name="municipality" className="ui selection dropdown">
                                <option disabled selected={project.municipality === undefined}>
                                    -- Auswählen --
                                </option>
                                {municipalities.map((m) => (
                                    <option
                                        key={m.bfsNr}
                                        value={m.bfsNr}
                                        selected={project.municipality?.bfsNr === m.bfsNr}
                                    >
                                        {m.name}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(project, "place")}
                        desc={getDesc(project, "place")}
                        inputElement={<Input type="text" name="place" defaultValue={project.place}/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(project, "status")}
                        desc={getDesc(project, "status")}
                        inputElement={
                            <select name="status" className="ui selection dropdown">
                                {keyValueStore.projectStatuses.map((s) => (
                                    <option
                                        key={s.key}
                                        value={s.key}
                                        selected={project.projectDto.status === s.key}
                                    >
                                        {s.value}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(project, "ebageNr")}
                        desc={getDesc(project, "ebageNr")}
                        inputElement={<Input type="text" name="ebageNr" defaultValue={project.ebageNr}/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(project, "enactmentDateDisplayText")}
                        desc={getDesc(project, "enactmentDateDisplayText")}
                        inputElement={<MyDatePicker name="enactmentDate" value={project.enactmentDate}/>}
                    />
                    <LabeledInput
                        label={getLabel(project, "approvedCreationArea")}
                        desc={getDesc(project, "approvedCreationArea")}
                        inputElement={<Input name="approvedCreationArea" type="number"
                                             defaultValue={project.approvedCreationArea}/>}
                    />
                    <LabeledInput
                        label={getLabel(project, "creationGoalSource")}
                        inputElement={
                            <select name="creationGoalSource" className="ui selection dropdown">
                                <option
                                    key={-1} value=""
                                    selected={project.projectDto.creationGoalSource === null}>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.creationGoalSources.map((e) => (
                                    <option
                                        key={e.key}
                                        value={e.key}
                                        selected={project.projectDto.creationGoalSource === e.key}
                                    >
                                        {e.value}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(project, "landOwnerFullName")}
                        desc={getDesc(project, "landOwnerFullName")}
                        inputElement={
                            <select name="landOwnerId" className="ui selection dropdown">
                                <option
                                    key={-1} value=""
                                    selected={project.landOwner === undefined}>
                                    -- Auswählen --
                                </option>
                                {contacts.map(c => (
                                    <option
                                        key={c.id}
                                        value={c.id}
                                        selected={project.landOwner?.id === c.id}
                                    >{`${c.firstName} ${c.lastName}`}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(project, "cmiNumberRawi")}
                        desc={getDesc(project, "cmiNumberRawi")}
                        inputElement={<Input type="text" name="cmiNrRawi" defaultValue={project.cmiNumberRawi}/>}
                    />
                    <LabeledInput
                        label={getLabel(project, "geometrySource")}
                        desc={getDesc(project, "geometrySource")}
                        inputElement={<Input type="text" maxLength={50} name="geometrySource"
                                             defaultValue={project.geometrySource}/>}
                    />
                    <LabeledInput
                        label={getLabel(project, "geometrySourceDateDisplayText")}
                        desc={getDesc(project, "geometrySourceDateDisplayText")}
                        inputElement={<MyDatePicker name="geometrySourceDate" value={project.geometrySourceDate}/>}
                    />
                    <LabeledInput
                        label={getLabel(project, "constructionSupervisorFullName")}
                        desc={getDesc(project, "constructionSupervisorFullName")}
                        inputElement={
                            <select name="constructionSupervisorId" className="ui selection dropdown">
                                <option
                                    key={-1} value=""
                                    selected={project.constructionSupervisor === undefined}>
                                    -- Auswählen --
                                </option>
                                {contacts.map(c => (
                                    <option
                                        key={c.id}
                                        value={c.id}
                                        selected={project.constructionSupervisor?.id === c.id}
                                    >{`${c.firstName} ${c.lastName}`}</option>
                                ))}
                            </select>
                        }
                    />
                </GridColumn>
                <GridColumn>
                    <LabeledInput
                        label={getLabel(project, "requirementsSpecificationBBBStatus")}
                        desc={getDesc(project, "requirementsSpecificationBBBStatus")}
                        inputElement={
                            <select name="requirementsSpecificationBBBStatus" className="ui selection dropdown">
                                <option
                                    key={-1} value=""
                                    selected={project.projectDto.requirementsSpecificationBBBStatus === null}>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlStatuses.map(e => (
                                    <option
                                        key={e.key}
                                        value={e.key}
                                        selected={project.projectDto.requirementsSpecificationBBBStatus === e.key}
                                    >{e.value}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(project, "requirementsSpecificationRequestSource")}
                        desc={getDesc(project, "requirementsSpecificationRequestSource")}
                        inputElement={
                            <select name="requirementsSpecificationRequestSource" className="ui selection dropdown">
                                <option
                                    key={-1} value=""
                                    selected={project.projectDto.requirementsSpecificationRequestSource === null}>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlSources.map(e => (
                                    <option
                                        key={e.key}
                                        value={e.key}
                                        selected={project.projectDto.requirementsSpecificationRequestSource === e.key}
                                    >{e.value}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(project, "startConstructionMeetingStatus")}
                        desc={getDesc(project, "startConstructionMeetingStatus")}
                        inputElement={
                            <select name="startConstructionMeetingStatus" className="ui selection dropdown">
                                <option
                                    key={-1} value=""
                                    selected={project.projectDto.startConstructionMeetingStatus === null}>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlStatuses.map(e => (
                                    <option
                                        key={e.key}
                                        value={e.key}
                                        selected={project.projectDto.startConstructionMeetingStatus === e.key}
                                    >{e.value}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(project, "startConstructionMeetingSource")}
                        desc={getDesc(project, "startConstructionMeetingSource")}
                        inputElement={
                            <select name="startConstructionMeetingSource" className="ui selection dropdown">
                                <option
                                    key={-1} value=""
                                    selected={project.projectDto.startConstructionMeetingSource === null}>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlSources.map(e => (
                                    <option
                                        key={e.key}
                                        value={e.key}
                                        selected={project.projectDto.startConstructionMeetingSource === e.key}
                                    >{e.value}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledTextArea label={getLabel(project, "generalRemarks")}
                                     name="generalRemarks"
                                     defaultValue={project.generalRemarks}/>
                    <LabeledTextArea label={getLabel(project, "enactmentRemarks")}
                                     name="enactmentRemarks"
                                     defaultValue={project.enactmentRemarks}/>
                    <LabeledTextArea label={getLabel(project, "creationGoalRemarks")}
                                     name="creationGoalRemarks"
                                     defaultValue={project.creationGoalRemarks}/>
                </GridColumn>
            </Grid>
        </div>
    );
}
